import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import "./App.css";
import Layout from "./layouts/Layout";
import Clothing from "./pages/Clothing";
import Collection from "./pages/Collection";
import Home from "./pages/Home";
import "react-toastify/dist/ReactToastify.css";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";
import { Helmet } from "react-helmet";
function App() {
  return (
    <div>
      <Helmet titleTemplate="%s | fashion" defaultTitle="home" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/home" element={<Navigate to={"/"} />} />
          </Route>
          <Route path="/collections" element={<Layout />}>
            <Route index element={<Collection />} />
            {/* <Route path=":collection" element={<Collection />} /> */}
            <Route path=":collection">
              <Route index element={<Clothing />} />
              <Route path="products/:id" element={<ProductDetails />} />
            </Route>
          </Route>
          <Route path="*" element={<div>Erro</div>} />
          <Route path="/cart" element={<Layout />}>
            <Route index element={<Cart />} />
          </Route>
          <Route path="/wishlist" element={<Layout />}>
            <Route index element={<Wishlist />} />
          </Route>
          <Route path="/about" element={<Layout />}>
            <Route index element={<About />} />
          </Route>
          <Route path="/contact" element={<Layout />}>
            <Route index element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
